import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Grid from '@mui/material/Grid';
import Hidden from '@mui/material/Hidden';
import ImageListItem from '@mui/material/ImageListItem';
import showThreeColumnShape from 'shapes/components/showThreeColumnShape';
import ShowCard, { SHOW_CARD_SIZES } from 'components/ShowCard';
import ImageList from '@mui/material/ImageList';

const ShowThreeColumnContainer = styled.div`
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  .MuiGrid-container {
    margin-top: 0;
  }
`;

const ImageListItemContainer = styled(ImageListItem)`
  height: auto !important;
  // appropriate use of important tag as this component is an exception where we need to override mui styling
`;

const propTypes = {
  data: showThreeColumnShape,
  className: PropTypes.string,
};

function ShowThreeColumn({ data, className }) {
  const { leftColumnShow, middleColumnShow, rightColumnShow, isMobileSlider, shouldLazyLoad } = data;

  if (!leftColumnShow && !middleColumnShow && !rightColumnShow) {
    return null;
  }
  return (
    <ShowThreeColumnContainer className={className}>
      {/* Tablet/Desktop shows list */}
      <Hidden smDown={isMobileSlider}>
        <Grid container rowSpacing={1} columnSpacing={1}>
          {[leftColumnShow, middleColumnShow, rightColumnShow].map((show, i) => (
            <Grid item xs={12} sm={4} key={i}>
              {show && <ShowCard show={show} size={SHOW_CARD_SIZES.featured} shouldLazyLoad={shouldLazyLoad} />}
            </Grid>
          ))}
        </Grid>
      </Hidden>
      {/* Mobile-only shows list */}
      <Hidden smDown={!isMobileSlider} smUp>
        <ImageList spacing={16} tileWidth='78%'>
          {[leftColumnShow, middleColumnShow, rightColumnShow].map((show, i) => (
            <ImageListItemContainer key={i} component='div'>
              {show && <ShowCard show={show} size={SHOW_CARD_SIZES.featured} shouldLazyLoad={shouldLazyLoad}/>}
            </ImageListItemContainer>
          ))}
        </ImageList>
      </Hidden>
    </ShowThreeColumnContainer>
  );
}

ShowThreeColumn.propTypes = propTypes;

export default ShowThreeColumn;
